import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { ApiState } from 'models';
import { resetAll } from 'reducers';
import { getPaymentsList, PaymentType } from 'services';

export type State = ApiState<Array<PaymentType>, SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchPaymentsList = createAsyncThunk(
  'get/paymentsList',
  async (phoenixPatientID: number) => await getPaymentsList(phoenixPatientID)
);

export const initialState = {
  isLoading: false,
  hasLoaded: false,
  data: [],
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const paymentsListSlice = createSlice({
  name: 'paymentsList',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPaymentsList.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchPaymentsList.fulfilled, (state, action: PayloadAction<Array<PaymentType>>) => {
      state.isLoading = false;
      state.data = action.payload;
      state.hasLoaded = true;
    });

    builder.addCase(fetchPaymentsList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });

    builder.addCase(resetAll, () => initialState);
  },
});

export const stateSelector_ = (state: { paymentsList: State }): State => state.paymentsList;

export const paymentsList_ = createSelector(stateSelector_, (state) => state.data);

export default paymentsListSlice.reducer;
